(function($) {
    $('.search-result-form').submit(function () {
        var $widget = $(this);
        var $pageNumberInput = $widget.find('.page-number');
        var currentPageNumber = parseInt($pageNumberInput.val());
        var $sender = $(document.activeElement);
        if ($sender.hasClass('search')) {
            currentPageNumber = 1;
        }
        else if ($sender.hasClass('previous')) {
            currentPageNumber--;
        } else if ($sender.hasClass('next')) {
            currentPageNumber++;
        }
        $pageNumberInput.val(currentPageNumber);
    });
})(window.jQuery);